import { render } from "./CreationButton.vue?vue&type=template&id=9ca7381a"
import script from "./CreationButton.vue?vue&type=script&lang=js"
export * from "./CreationButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__